// DatabaseManager.js
class DatabaseManager {
  constructor(dbName, version) {
    this.dbName = dbName;
    this.version = version;
    this.db = null;
    this.stores = new Map();
  }

  registerStore(storeName, config = {}) {
    console.log(`Registering store: ${storeName}`);
    this.stores.set(storeName, {
      keyPath: config.keyPath || "id",
      indexes: config.indexes || [],
      ...config,
    });
  }

  async initDatabase() {
    return new Promise((resolve, reject) => {
      console.log(`Opening database: ${this.dbName}, version: ${this.version}`);
      const request = indexedDB.open(this.dbName, this.version);

      request.onerror = () => {
        reject(new Error(`Failed to open database: ${request.error}`));
      };

      request.onsuccess = (event) => {
        this.db = event.target.result;
        console.log("Database opened successfully");
        resolve(this.db);
      };

      request.onupgradeneeded = (event) => {
        console.log("Database upgrade needed");
        const db = event.target.result;
        try {
          this.createStores(db);
        } catch (error) {
          console.error("Error during store creation:", error);
          event.target.transaction.abort();
          reject(new Error(`Database upgrade failed: ${error.message}`));
        }
      };
    });
  }

  createStores(db) {
    for (const [storeName, config] of this.stores) {
      if (!db.objectStoreNames.contains(storeName)) {
        const store = db.createObjectStore(storeName, {
          keyPath: config.keyPath,
          autoIncrement: config.autoIncrement || false,
        });

        if (config.indexes) {
          for (const index of config.indexes) {
            store.createIndex(index.name, index.keyPath, {
              unique: index.unique || false,
              multiEntry: index.multiEntry || false,
            });
          }
        }
      }
    }
  }

  async deleteDatabase() {
    if (this.db) {
      this.db.close();
      this.db = null;
    }

    return new Promise((resolve, reject) => {
      const request = indexedDB.deleteDatabase(this.dbName);
      request.onsuccess = () => resolve();
      request.onerror = () => reject(request.error);
    });
  }

  async executeTransaction(storeName, mode, callback) {
    if (!this.db) {
      await this.initDatabase();
    }

    // 檢查 store 是否存在
    if (!this.db.objectStoreNames.contains(storeName)) {
      throw new Error(
        `Object store '${storeName}' not found in database '${this.dbName}'`
      );
    }

    return new Promise((resolve, reject) => {
      const transaction = this.db.transaction(storeName, mode);
      const store = transaction.objectStore(storeName);

      let result;
      try {
        result = callback(store);

        transaction.oncomplete = () => {
          resolve(result);
        };

        transaction.onerror = () => {
          reject(transaction.error);
        };

        transaction.onabort = () => {
          reject(transaction.error);
        };
      } catch (error) {
        reject(error);
      }
    });
  }
}

export default DatabaseManager;
